// removed by extract-text-webpack-plugin
module.exports = {"root":"organization-home--root--29mpR9MJ","new-products":"organization-home--new-products--F5mLSEod","newProducts":"organization-home--new-products--F5mLSEod","banner":"organization-home--banner--2HeQ3o5k","background":"organization-home--background--1Pbfx7wX"};


//////////////////
// WEBPACK FOOTER
// ./views/home/organization-home/styles.css
// module id = ./views/home/organization-home/styles.css
// module chunks = 0